import { __ } from "services/Translator";
import {
  CloverIcon,
  DepositNavIcon,
  WithdrawNavIcon,
  BonusesNavIcon,
  VipNavIcon,
  HistoryNavIcon,
  LimitsNavIcon,
  CrownFilledIcon,
} from "./icons";

const WALLET_NAV = [
  { view: "deposit", label: "Deposit", Icon: DepositNavIcon },
  { view: "withdraw", label: "Withdrawal", Icon: WithdrawNavIcon },
  { view: "bonuses", label: "Bonuses", Icon: BonusesNavIcon },
  { view: "vip", label: "VIP Level", Icon: VipNavIcon },
];

const ACTIVITY_NAV = [
  { view: "history", label: "History", Icon: HistoryNavIcon },
  { view: "limits", label: "Limits", Icon: LimitsNavIcon },
];

function NavLink({ item, active, tag, onClick }) {
  const { Icon } = item;
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      className={active ? "on" : undefined}
      role="button"
      tabIndex={0}
      onClick={() => onClick(item.view)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick(item.view);
        }
      }}
    >
      <span className="ic">
        <Icon />
      </span>
      <span className="lb">{__(item.label)}</span>
      {tag ? <span className="tag">{tag}</span> : null}
    </a>
  );
}

export default function Sidebar({ view, onNavigate, balanceFormatted, vip, withdrawable, bonusesCount }) {
  const hasVip = !!(vip && vip.tierName);
  const vipPct = hasVip && Number.isFinite(Number(vip.progressPct)) ? Number(vip.progressPct) : 0;
  const bonusTag = bonusesCount ? String(bonusesCount) : null;

  return (
    <aside className="side">
      <div className="brand">
        <span className="clover">
          <CloverIcon />
        </span>
        <div className="bt">
          <small>{__("Golden Clover")}</small>
          <b>{__("Cashier")}</b>
        </div>
      </div>

      <div className="balance">
        <small>{__("Balance")}</small>
        {balanceFormatted ? <b>{balanceFormatted}</b> : <b className="skel" aria-hidden="true" />}
        {withdrawable ? (
          <div className="sub">
            {__("Withdrawable")} · {withdrawable}
          </div>
        ) : null}
      </div>

      <nav className="nav">
        <div className="navlbl">{__("Wallet")}</div>
        {WALLET_NAV.map((item) => (
          <NavLink
            key={item.view}
            item={item}
            active={view === item.view}
            tag={item.view === "bonuses" ? bonusTag : null}
            onClick={onNavigate}
          />
        ))}
        <div className="navlbl" style={{ marginTop: "14px" }}>
          {__("Activity")}
        </div>
        {ACTIVITY_NAV.map((item) => (
          <NavLink key={item.view} item={item} active={view === item.view} onClick={onNavigate} />
        ))}
      </nav>

      {hasVip ? (
        <div className="vipcard">
          <div className="top">
            <span className="crown">
              <CrownFilledIcon />
            </span>
            <div>
              <b>{vip.tierName}</b>
              <small>{__("VIP Level")}</small>
            </div>
          </div>
          <div className="vipbar">
            <i style={{ width: vipPct + "%" }} />
          </div>
          {vip.nextTierName ? (
            <div className="lbl">
              {vip.toNextLabel} {__("to")} <b>{vip.nextTierName}</b>
            </div>
          ) : (
            <div className="lbl">{__("You have reached the highest tier")}</div>
          )}
        </div>
      ) : null}
    </aside>
  );
}
